import React from 'react';
import CollectionsManagementsCreated from './components/Created';
// import CollectionsManagementsSuggested from './components/Suggested';
import CollectionsManagementsGroupedBy from './components/GroupedBy';

const CollectionsManagements: React.FC = () => {
  return (
    <div>
      <CollectionsManagementsGroupedBy />
      {/* <CollectionsManagementsCreated /> */}
      <CollectionsManagementsCreated completed />
      {/* <CollectionsManagementsSuggested /> */}
    </div>
  );
};

export default CollectionsManagements;
